import { useLazyQuery } from '@netfront/apollo-providers';

import { START_STRIPE_SESSION_QUERY } from './useStartStripeSession.graphql';
import {
  IHandleStartStripeSessionParams,
  IUseStartStripeSession,
  IUseStartStripeSessionOptions,
} from './useStartStripeSession.interfaces';

const useStartStripeSession = (options?: IUseStartStripeSessionOptions): IUseStartStripeSession => {
  const { fetchPolicy, onCompleted, onError } = options ?? ({} as IUseStartStripeSessionOptions);

  const { handleQuery: executeStartStripeSession, isLoading } = useLazyQuery({
    apiName: 'muriqui',
    fetchPolicy: fetchPolicy ?? 'cache-and-network',
    onCompleted: (data) => {

      if (!onCompleted) {
        return;
      }

      const {
        projects: { startStripeSession },
      } = data;

      onCompleted({
        startStripeSession,
      });
    },
    onError,
    query: START_STRIPE_SESSION_QUERY,
  });

  const handleStartStripeSession = async ({ id, product, returnUrl }: IHandleStartStripeSessionParams) => {
    await executeStartStripeSession({
      id,
      product,
      returnUrl,
    });
  };

  return {
    handleStartStripeSession,
    isLoading,
  };
};

export { useStartStripeSession };
